import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { injectable, inject, initializer } from "@launchtray/tsyringe-async";
import { IMarketplaceViewModel } from "./IMarketplaceViewModel";
import { IPlayerModel } from "../../../../common/models/IPlayerModel";
import { MapFilter, MonOrderType } from "./map/MapFilter";
import { MarketplaceCard } from "../components/MarketplaceCard";
import { BuildingRightsType } from "../../../../../networking/data/responses/user/BuildingRightsType";
import { MarketplaceSceneOptions } from "../MarketplaceScene";

@injectable()
export class MarketplaceViewModel extends Bindable implements IMarketplaceViewModel {
    private readonly playerModel: IPlayerModel;
    public readonly defaultSelectedZoneId: NotifyProperty<number>;
    public readonly currentMapFilter: NotifyProperty<MapFilter>;
    public readonly selectedMarketplaceCard: NotifyProperty<MarketplaceCard>;
    public readonly returnOnlyBuildingsByMon: NotifyProperty<boolean>;
    public readonly orderByPriceInMon: NotifyProperty<MonOrderType>;

    public constructor(
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("MarketplaceSceneOptions") options: MarketplaceSceneOptions
    ) {
        super();
        this.playerModel = playerModel;
        this.defaultSelectedZoneId = new NotifyProperty<number>(this, nameof(this, "defaultSelectedZoneId"), 1);
        this.selectedMarketplaceCard = new NotifyProperty<MarketplaceCard>(this, nameof(this, "selectedMarketplaceCard"), null);
        this.currentMapFilter = new NotifyProperty<MapFilter>(this, nameof(this, "currentMapFilter"), null);
        this.returnOnlyBuildingsByMon = new NotifyProperty<boolean>(this, nameof(this, "returnOnlyBuildingsByMon"), false);
        this.orderByPriceInMon = new NotifyProperty<MonOrderType>(this, nameof(this, "orderByPriceInMon"), null);
        this.defaultSelectedZoneId.setValue(options.buildingArea === -1 ? this.getSelectedZoneId() : options.buildingArea);
        this.currentMapFilter.setValue(new MapFilter(this.defaultSelectedZoneId.value));
    }

    private getSelectedZoneId(): number {
        const guestBuildings = this.playerModel.buildings.value;
        let selectedAreaId = 1;
        if (this.playerModel.buildingRights.value === BuildingRightsType.OWNER) {
            const myBuilding = guestBuildings.find(building => building.marketplaceId.value != null);
            if (myBuilding != null) {
                selectedAreaId = myBuilding.area.value;
            }
        }
        return selectedAreaId;
    }
}
